module.exports = __webpack_public_path__ + "assets/recenter-map.e89c97d40ae605d69cbf6c00969720ef.svg";